import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const eventObjectsPublishApi = createAsyncThunk(
  "auth/eventObjectsPublish",
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data
      const response = await AuthAxios.put(
        apiRoutes.publicapiAction(`event-objects/${id}`, 1), data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const eventObjectsPublishSlice = createSlice({
  name: "eventObjectsPublish",
  initialState: { result: [], loading: false, error: null, message: "", total: 0 },
  extraReducers: (builder) => {
    builder.addCase(eventObjectsPublishApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(eventObjectsPublishApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results?.result ?? [];
      state.message = action?.payload?.message;
      state.total = action?.payload?.count
    });
    builder.addCase(eventObjectsPublishApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const eventObjectsPublishreducer = eventObjectsPublishSlice.reducer;
